import React, { useEffect, useState } from "react";
import { Gift, Copy, Users, Check } from "lucide-react";
import { toast } from "sonner";
import api from "@/lib/api";
import { useLang } from "@/context/LanguageContext";

const C = {
  fr: { title: "Programme de parrainage", subtitle: "Partagez votre lien et faites profiter vos proches de notre accompagnement.",
    yourLink: "Votre lien de parrainage", intro: "Invitez vos amis : lorsqu'ils créent un compte via votre lien, ils apparaissent parmi vos filleuls.",
    copy: "Copier le lien", copied: "Copié", copyOk: "Lien copié !", copyErr: "Impossible de copier.",
    yourCode: "Votre code :", myReferrals: "Mes filleuls", none: "Aucun filleul pour l'instant. Partagez votre lien pour commencer !" },
  en: { title: "Referral program", subtitle: "Share your link and let your friends benefit from our support.",
    yourLink: "Your referral link", intro: "Invite your friends: when they create an account via your link, they appear among your referrals.",
    copy: "Copy link", copied: "Copied", copyOk: "Link copied!", copyErr: "Unable to copy.",
    yourCode: "Your code:", myReferrals: "My referrals", none: "No referral yet. Share your link to get started!" },
};

export default function Parrainage() {
  const { lang } = useLang();
  const c = C[lang];
  const [data, setData] = useState(null);
  const [copied, setCopied] = useState(false);

  useEffect(() => { api.get("/referral/me").then((r) => setData(r.data)).catch(() => {}); }, []);

  const link = data ? `${window.location.origin}/inscription?ref=${data.code}` : "";

  const copy = async () => {
    try { await navigator.clipboard.writeText(link); setCopied(true); toast.success(c.copyOk); setTimeout(() => setCopied(false), 2000); }
    catch { toast.error(c.copyErr); }
  };

  return (
    <div data-testid="parrainage-page">
      <h1 className="font-heading text-3xl sm:text-4xl text-navy">{c.title}</h1>
      <p className="text-muted-foreground mt-2">{c.subtitle}</p>

      <div className="mt-8 bg-navy text-white p-8">
        <div className="flex items-center gap-3"><Gift size={24} className="text-gold" /><h2 className="font-heading text-2xl">{c.yourLink}</h2></div>
        <p className="text-white/70 text-sm mt-2">{c.intro}</p>
        <div className="mt-6 flex flex-col sm:flex-row gap-3">
          <input data-testid="referral-link" readOnly value={link} className="flex-1 bg-white/10 border border-white/20 px-4 py-3 text-sm text-white truncate" />
          <button data-testid="copy-referral" onClick={copy} className="bg-gold hover:bg-gold-hover text-white px-6 py-3 font-medium flex items-center justify-center gap-2 transition-colors">
            {copied ? <><Check size={16} /> {c.copied}</> : <><Copy size={16} /> {c.copy}</>}
          </button>
        </div>
        {data && <p className="mt-4 text-sm text-white/60">{c.yourCode} <span className="text-gold font-semibold tracking-widest">{data.code}</span></p>}
      </div>

      <div className="mt-8">
        <h2 className="flex items-center gap-2 font-heading text-2xl text-navy"><Users size={22} className="text-gold" /> {c.myReferrals} {data ? `(${data.count})` : ""}</h2>
        {!data || data.referrals.length === 0 ? (
          <div className="bg-white border border-border p-8 text-center mt-4 text-muted-foreground text-sm">{c.none}</div>
        ) : (
          <div className="bg-white border border-border divide-y divide-border mt-4">
            {data.referrals.map((r) => (
              <div key={r.id} className="flex items-center justify-between p-4">
                <div>
                  <p className="text-navy font-medium">{r.referred_name}</p>
                  <p className="text-xs text-muted-foreground">{r.referred_email}</p>
                </div>
                <span className="text-xs text-muted-foreground">{r.created_at?.slice(0, 10)}</span>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}
